import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { mimeTypeToIconMapping } from '../../../helpers/mime-type_to_icon';
import CollectionCoordinates from '../CoordinatesGrids/CollectionCoordinates';
import RestitutionCoordinates from '../CoordinatesGrids/RestitutionCoordinates';

const Coordinates = ({ intakeCoordinatesList, setIntakeCoordinatesList, restitutionCoordinatesList, setRestitutionCoordinatesList, formIsEdit, waterRightId }) => {

    return (
        <React.Fragment>
            <Col lg={12}>
                <CollectionCoordinates 
                    intakeCoordinatesList={intakeCoordinatesList}
                    setIntakeCoordinatesList={setIntakeCoordinatesList}
                    formIsEdit={formIsEdit}
                    waterRightId={waterRightId}
                />
            </Col>
            <Col lg={12}>
               <RestitutionCoordinates
                    restitutionCoordinatesList={restitutionCoordinatesList}
                    setRestitutionCoordinatesList={setRestitutionCoordinatesList}
                    formIsEdit={formIsEdit}
                    waterRightId={waterRightId}
               />
            </Col>
        </React.Fragment>
    )
}

export default Coordinates;